import Button from 'assets/components/button/Button';
import ThemeButtonMenuItem from 'assets/components/button/themes/Theme.Button.MenuItem';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import { getLocales } from 'assets/locales/Locale';
import { useAuthStore } from 'assets/providers/authStore/Provider.AuthStore';
import DropdownButton from 'assets/templates/dropdownButton/DropdownButton';
import ThemeDropdownButtonPopup from 'assets/templates/dropdownButton/themes/Theme.DropdownButton.Popup';
import { get } from 'lodash';
import ContractStatusCode from 'models/enums/ContractStatusCode';
import contractSetStatusApi from 'models/sales/contract/setStatus/Api.Contract.SetStatus';
import { useSalesContractProvider } from '../Sales.Contract.Hooks';
import { HttpStatus } from 'config/Api.Config';
import { addLog } from 'assets/components/feedback/Feedback';

type Props = {
  statusInfo: Api.Core.Contract.StatusFlow.IResponse;
  disabled?: boolean;
  active?: boolean;
  currentStatus: Model.Enum.ContractStatusCode;
  contractId: number;
  onChange(): void;
};
export default function ContractStatusStateMachine({
  statusInfo,
  currentStatus,
  contractId,
  disabled,
  active,
  onChange,
}: Props) {
  const { pageRouter, setIsStatusChanging } = useSalesContractProvider();
  const { permissions } = useAuthStore();
  const { lang } = getLocales();

  const nextStatusList = get(statusInfo, currentStatus);

  const isDisabled = !permissions.UPDATE_CONTRACT_STATUS || !nextStatusList?.length || disabled;
  return (
    <DropdownButton
      buttonMedia={<Icon class="fas-check-double" />}
      horizontalPosition="auto_fixed"
      verticalPosition="auto_fixed"
      subcomponents={ThemeDropdownButtonPopup}
      htmlElementProps={{ title: lang.changeStatus }}
      disabled={isDisabled}
      active={active}
      tabIndex={null}
      dropdownOptions={({ animateOut }) => (
        <DataMap
          data={nextStatusList}
          render={({ data: status }) => (
            <Button
              key={status}
              onClick={async (newStatus) => {
                animateOut();

                if (newStatus === ContractStatusCode.PAID_ACTIVE) {
                  pageRouter.updateParams({
                    id: contractId.toString(),
                    action: 'paid-active', // novi action
                  });
                  return;
                }

                if (
                  newStatus !== ContractStatusCode.CANCELED_REFUND_PR_REFUND &&
                  newStatus !== ContractStatusCode.CANCELED_VOID
                ) {
                  setIsStatusChanging(true);
                  const res = await contractSetStatusApi(contractId, { newStatus, triggerStatusFlow: true });

                  if (res.status === HttpStatus.ok) {
                    setIsStatusChanging(false);
                    onChange();
                    addLog({ success: lang.contractStatusSuccesfullyChanged });
                  } else {
                    setIsStatusChanging(false);
                    addLog({ error: res.message });
                  }
                }

                if (newStatus === ContractStatusCode.CANCELED_REFUND_PR_REFUND) {
                  pageRouter.updateParams({
                    id: contractId.toString(),
                    action: 'cancellation-restricted',
                  });
                }

                if (newStatus === ContractStatusCode.CANCELED_VOID) {
                  pageRouter.updateParams({
                    id: contractId.toString(),
                    action: 'cancellation-void',
                  });
                }
              }}
              // TODO: Add and delete old flow when contract refund is fully enabled!
              // onClick={async (newStatus) => {
              //   animateOut();

              //   if (newStatus !== ContractStatusCode.CANCELED_VOID) {
              //     setIsStatusChanging(true);
              //     const res = await contractSetStatusApi(contractId, { newStatus, triggerStatusFlow: true });

              //     if (res.status === HttpStatus.ok) {
              //       setIsStatusChanging(false);
              //       onChange();
              //       addLog({ success: lang.contractStatusSuccesfullyChanged });
              //     } else {
              //       setIsStatusChanging(false);
              //       addLog({ error: res.message });
              //     }
              //   }

              //   if (newStatus === ContractStatusCode.CANCELED_VOID) {
              //     pageRouter.updateParams({
              //       id: contractId.toString(),
              //       action: 'cancellation-void',
              //     });
              //   }
              // }}
              data={status}
              render={lang[status]?.replace('_', ' - ')}
              class={ThemeButtonMenuItem}
            />
          )}
        />
      )}
    />
  );
}
